import { client } from "src/services/client";

export const fetchCalculation = async (query: { [key: string]: number }) =>
    client({
        method: "post",
        url: `/listings/residential/mortgage`,
        headers: { "Content-Type": "application/json" },
        data: query,
    }).then((response) => response.data);
